
<!-- 
<div class="modal fade zoomIn show timeoutmodel" id="CutofTimeMsg" tabindex="-1" aria-hidden="true" style="display: none;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header" style="text-align: center;">
                <h4 id="dialog-child-name" class="modal-title pull-left">Live Chat Offline</h4>
            </div>
            <div class="modal-body text-center">
                <div class="mt-2 text-center">
                    <h4 class="fs-semibold mb-5"> Our tellers are currently unavailable. We will respond to your message during the next business day.</h4>
                   
                   
            </div>
        </div>
    </div>
</div>
</div> -->
<div class="modal fade zoomIn show " id="CutofTimeMsg" tabindex="-1" aria-hidden="true" style="display: none;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header " >
                <h4 id="dialog-child-name" class="modal-title pull-left">Live Chat Offline</h4>
            </div>
            <div class="modal-body text-center">
                <div class="mt-2 text-center">
                    <h4 class="fs-semibold mb-5"> Our tellers are currently unavailable. We will respond to your message during the next business day.</h4>
                   
                </div>
            </div>
        </div>
    </div>
</div>